<!-- //
dialog 文档预览
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="calc(100% - 400px)">
    <div style="border: 1px solid #e1e1e1; padding: 20px;">
      <doc-preview :form-data="this.form"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DocPreview from './doc-preview';

export default {
  name: 'ViewDocPreviewDlg',
  components: {DocPreview},
  data() {
    return {
      visible: false,
      title: '文档预览',
      opts: {},
      form: {
        id: null,
        title: null,
        createUser: null,
        createTime: null,
        updateUser: null,
        updateTime: null,
        docContent: null,
      },
    }
  },
  methods: {
    showModal({data, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      this.visible = true;
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(this.form, opts.data)
      this.form = opts.data
    },

    hideModal() {
      this.visible = false;
    },
  }
}
</script>

<style lang="less" scoped>
</style>
